import { render, staticRenderFns } from "./TaxpayerCodeModel.vue?vue&type=template&id=81ffcba0&scoped=true"
import script from "./TaxpayerCodeModel.vue?vue&type=script&lang=js"
export * from "./TaxpayerCodeModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ffcba0",
  null
  
)

export default component.exports